import React, { useMemo } from "react";

import List from "devextreme-react/list";

import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { fxReactSelectedPage } from "@app/statefx/xThunks/uiDrawer";
import "@app/style/dx.generic.catetory-chooser-compact.min.css";

import "./drawer.scss";

export const MenuDetail = ({ data }: { data: any }) => {
  const dispatch = useFxDispatch();
  const theChooser = useFxSelector(schema.categoryChooser.select);

  //???
  const currentParent = useMemo(() => theChooser.currentParent, [theChooser]);
  const currentPage = useMemo(() => theChooser.currentChild, [theChooser]);

  const categoryChooser = useMemo(() => {
    return theChooser.items.filter((x) => x.parentId === data?.name);
  }, [theChooser, data.name]);

  const items = useMemo(() => categoryChooser, [data?.name]);
  console.log("categoryChooser", categoryChooser);

  const onSelectedItemKeysChange = (args: any) => {
    console.log("args", args);
    if (args.name === "selectedItemKeys") {
      if (currentPage === args.value?.[0]) return;
      console.log("currentPage", currentPage);
      console.log("args.value?.[0]", args.value?.[0]);

      dispatch(fxReactSelectedPage(args.value?.[0]));
    }
  };

  return (
    <List
      key={`${data?.id}/${data?.name}`}
      id={"menuDetail"}
      className={`${currentParent === data?.id ? "inscope" : "outofscope"}`}
      keyExpr={"id"}
      dataSource={items}
      displayExpr="name"
      selectedItemKeys={[currentPage]}
      onOptionChanged={onSelectedItemKeysChange}
      selectionMode="single"
      style={{ cursor: "default" }} // Set the cursor style here
    />
  );
};
